export default __webpack_public_path__ + "static/media/pokemon_fighting.5433fbce.png";